import { HeadingProps } from '@usacsmideo/types';

export const Heading = (props: HeadingProps) => {
  return (
    <p id={props.id} className="text-mideo-darkred mb-4 place-self-center text-3xl font-bold">
      {props.textContent}
    </p>
  );
};
